<template>
  <div id="about__main">
    <b-jumbotron id="header_about">
      <h2 class="text-center text-uppercase">Sobre Nós</h2>
    </b-jumbotron>
    <BreadSistema class="bread__about" />

    <b-container fluid>
      <div class="d-flex align-items-center justify-content-center">
        <div class="clearfix">
          <div class="float-left box-image">
            <div class="text-center">
              <img src="../../assets/images/image-pages/image_sobre-sistemacpv.png">
            </div>
          </div>
          <div class="float-right box-text text-left">
            <div class="content-text mt-lg-0 mt-xl-1">
              <h3 class="text-center text-uppercase font-weight-bold year">{{ ano }} Anos de História</h3>
              <div class="mt-4">
                <p>Nossa história começa em 1959, atuando na preparação de alto nível para os vestibulares mais
                  concorridos de São Paulo.</p>
                <p>Com o tempo, percebemos que o nosso material, feito sob medida para suprir a defasagem de
                  conhecimento
                  dos
                  alunos, era um dos grandes motivos para nossa excelente performance.</p>
                <p>Assim nasceu o <strong>Sistema de Ensino CPV.</strong> A produção de material didádico foi concebida
                  a
                  partir
                  da nossa experiência e da nossa crença na educação como base da transformação da sociedade.</p>
                <p class="lead">Um projeto pedagógico consistente, comprometido em dar um tratamento aprofundado aos
                  conteúdos
                  curriculares, atualizado constantemente e de acordo com a BNCC, garante a qualidade do ensino às
                  instituições associadas.
                </p>
                <p>Ao nos posicionarmos como parceiros das escolas, nosso papel não termina com a entrega dos módulos:
                  esse é o momento
                  que marca apenas o início de uma caminhada em conjunto. Por meio da assessoria pedagógica, jurídica e
                  de
                  marketing
                  e da disponibilização de plataformas on-line de ensino personalizado <strong>(Alfred),</strong>
                  oferecemos
                  segurança e tecnologia para todos os departamentos da organização.
                </p>
              </div>
              <hr class="mt-2 mb-2" />

              <div class="d-block mx-auto">
                <h5 class="text-center font-weight-bolder text-uppercase">Para mais informações</h5>
                <p class="text text-center">
                  Para mais informações sobre esse material, solicite hoje um consultor do Sistema de Ensino CPV.
                </p>
                <div class="d-flex justify-content-center">
                  <b-button class="btn__consultor" :to="{ name: 'escolaParceira' }" variant="transparent">
                    <i class="fa-regular fa-messages"></i>
                    <span>Fale com um consultor</span>
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'sobre-nos',
  components: { BreadSistema: () => import('../GlobalComponents/bread-sistema.vue') },
  computed: {
    ano() {
      let currentTime = new Date();
      let year = currentTime.getFullYear();
      return year - 1959;
    }
  }
};
</script>

<style lang="scss" scoped>
#about__main {
  background-color: #ffffff;
  border-radius: 0;

  #header_about {
    background-color: #E88A06;
    background-image: url('https://d1jehvsxq7tgfk.cloudfront.net/sitecpv/images/cpv-fundo-4.png');
    object-fit: cover;
    border-radius: 0;

    h2 {
      color: #ffffff;

      font-size: 40px;
      font-weight: 600;

      line-height: 52px;
    }
  }

  .bread__about {
    margin-top: -32px;
  }

  h3,
  h5 {
    color: #e98b24;
  }

  p {
    font-size: 16px;
    line-height: 22px;
    padding: 5px 0;
  }

  .lead {
    color: #e98b24;
    font-size: 20px;
    font-weight: 800;
    line-height: 26px;
  }

  .btn__consultor {
    display: inline-flex;
    min-width: auto;
    min-height: auto;

    margin: 0px auto 0;
    padding: 8px 16px;

    gap: 6px;

    background-color: #e98b24;
    border: 1px solid #e98b24;
    border-radius: 5px;

    display: flex;
    align-items: center;

    font-size: 16px;
    line-height: 22px;

    color: #fdf3e9;

    .icon {
      width: 18px;
      height: 18px;

      display: flex;
      align-items: center;

      i {
        font-size: 16px;
        line-height: 22px;
      }
    }

    &:hover {
      background-color: #d27d20;
      transition: all 0.3s ease-in-out;
      border: 1px solid #d27d20;
    }
  }

  .decorator {
    border: 2px solid #f8dbbb;
    width: 60px;
    border-radius: 50px;
    margin-top: -10px;
  }
}

@media screen and (min-width: 1200px) {
  .box-image {
    margin-top: -16px;
    width: 50%;
    max-height: 1001px;
    // margin-bottom: 30px;

    img {
      display: block;
      margin-left: auto;
      margin-right: auto;
      height: auto;
      object-fit: cover;
    }
  }

  .box-text {
    margin: 25px auto;
    width: 50%;

    display: block;

    .content-text {
      padding-left: 32px;
      padding-right: 32px;
    }
  }
}

@media screen and (min-width: 992px) and (max-width: 1200px) {
  .box-image {
    width: 100%;
    margin-top: -0px;
    height: auto;
    margin-bottom: 30px;

    img {
      display: block;
      margin-left: auto;
      margin-right: auto;
      max-width: 100%;
      height: auto;
    }
  }

  .box-text {
    width: 100%;

    .content-text {
      padding-left: 16px;
      padding-right: 16px;
      margin-bottom: 20px;
    }
  }
}

@media screen and (min-width: 768px) and (max-width: 992px) {
  .box-image {
    width: 100%;
    margin-top: -0px;
    height: auto;
    margin-bottom: 30px;

    img {
      display: block;
      margin-left: auto;
      margin-right: auto;
      max-width: 100%;
      height: auto;
    }
  }

  .box-text {
    width: 100%;

    .content-text {
      padding-left: 16px;
      padding-right: 16px;
      margin-bottom: 20px;
    }
  }
}

@media screen and (min-width: 576px) and (max-width: 768px) {
  .box-image {
    width: 100%;
    margin-top: 0px;
    height: auto;
    margin-bottom: 30px;

    img {
      display: block;
      margin-left: auto;
      margin-right: auto;
      max-width: 100%;
      height: auto;
    }
  }

  .box-text {
    width: 100%;

    .content-text {
      padding-left: 16px;
      padding-right: 16px;
      margin-bottom: 20px;
    }
  }
}

@media screen and (max-width: 576px) {
  .box-image {
    width: 100%;
    margin-top: 0px;
    height: auto;
    margin-bottom: 30px;

    img {
      display: block;
      margin-left: auto;
      margin-right: auto;
      max-width: 100%;
      height: auto;
    }
  }

  .box-text {
    width: 100%;

    .content-text {
      padding-left: 16px;
      padding-right: 16px;
      margin-bottom: 20px;
    }
  }
}
</style>
